import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { BRAND_ICONS } from "./BrandIcons";
import { COMPANY, SOCIALS } from "../lib/content";

export const Footer = () => (
    <footer
        className="border-t border-blue-100 bg-gradient-to-r from-white via-blue-50 to-white shadow-[0_-4px_30px_rgba(37,99,235,0.08)]"
        data-testid="main-footer"
    >
        <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
            <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
                <div>
                    <div className="inline-flex" data-testid="footer-logo-wrap">
                        <Logo />
                    </div>
                    <p className="mt-4 text-sm leading-relaxed text-slate-600">
                        {COMPANY.tagline}. {COMPANY.actionLine}
                    </p>
                    <div className="mt-5 flex gap-2.5">
                        {SOCIALS.map((s) => {
                            const Icon = BRAND_ICONS[s.icon];
                            return (
                                <a
                                    key={s.name}
                                    href={s.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={`footer-social-${s.icon}`}
                                    aria-label={s.name}
                                    className="rounded-full border border-blue-100 bg-white p-2.5 text-slate-500 shadow-sm transition-colors hover:border-blue-400 hover:text-blue-600"
                                >
                                    <Icon className="h-4 w-4" />
                                </a>
                            );
                        })}
                    </div>
                </div>

                <div>
                    <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-slate-800">About Us</h4>
                    <ul className="mt-4 space-y-2.5 text-sm text-slate-600">
                        <li><Link data-testid="footer-founder-link" to="/founder" className="hover:text-blue-700">Founder</Link></li>
                        <li><Link data-testid="footer-company-link" to="/company" className="hover:text-blue-700">Company</Link></li>
                        <li><Link data-testid="footer-investors-link" to="/investors" className="hover:text-blue-700">For Investors</Link></li>
                        <li><Link data-testid="footer-blog-link" to="/blog" className="hover:text-blue-700">Blog</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-slate-800">Product</h4>
                    <ul className="mt-4 space-y-2.5 text-sm text-slate-600">
                        <li><Link data-testid="footer-pricing-link" to="/pricing" className="hover:text-blue-700">Pricing</Link></li>
                        <li><Link data-testid="footer-reviews-link" to="/reviews" className="hover:text-blue-700">Customer Reviews</Link></li>
                        <li><Link data-testid="footer-contact-link" to="/contact" className="hover:text-blue-700">Contact Us</Link></li>
                        <li>
                            <a data-testid="footer-whatsapp-link" href={COMPANY.whatsapp} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 hover:text-blue-700">
                                <MessageCircle className="h-3.5 w-3.5" /> WhatsApp Us
                            </a>
                        </li>
                        <li>
                            <a data-testid="footer-maps-link" href={COMPANY.maps} target="_blank" rel="noopener noreferrer" className="hover:text-blue-700">
                                Google Business Profile
                            </a>
                        </li>
                    </ul>
                </div>

                <div>
                    <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-slate-800">Legal</h4>
                    <ul className="mt-4 space-y-2.5 text-sm text-slate-600">
                        <li><Link data-testid="footer-terms-link" to="/terms" className="hover:text-blue-700">Terms & Conditions</Link></li>
                        <li><Link data-testid="footer-privacy-link" to="/privacy" className="hover:text-blue-700">Privacy Policy</Link></li>
                        <li><Link data-testid="footer-refund-link" to="/refund" className="hover:text-blue-700">Refund & Cancellation</Link></li>
                        <li><Link data-testid="footer-billing-link" to="/billing" className="hover:text-blue-700">Billing & Usage Policy</Link></li>
                        <li><Link data-testid="footer-media-link" to="/media" className="hover:text-blue-700">Media Coverage</Link></li>
                    </ul>
                    <p className="mt-6 text-xs leading-relaxed text-slate-500">
                        {COMPANY.legal}
                    </p>
                </div>
            </div>

            <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-blue-100 pt-6 text-xs text-slate-500 sm:flex-row">
                <span data-testid="footer-copyright">© 2026 {COMPANY.legal}. All rights reserved.</span>
                <span className="font-mono2 tracking-widest text-blue-600/80">{COMPANY.motto}</span>
            </div>
        </div>
    </footer>
);
